// export const ReactMdeToolbarCommandsDefault = [
//   ['header', 'bold', 'italic', 'strikethrough'],
//   ['link', 'quote', 'code', 'image'],
//   ['unordered-list', 'ordered-list', 'checked-list'],
// ]

export const ReactMdeToolbarCommands = [
  ['bold', 'italic'],
  ['quote', 'code', 'image'],
  ['unordered-list', 'ordered-list', 'checked-list'],
]

// 'br' is required for hard line breaks in multi-line question text to survive;
// react-markdown drops any element that is not listed here.
export const ReactMarkdownAllowedElements = ['p', 'strong', 'em', 'li', 'ol', 'ul', 'br']
